import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  ClipboardCheck,
  Building2,
  CreditCard,
  BarChart3,
  MoreHorizontal,
  Upload,
  Building,
  History,
  Map,
  Compass,
  X,
} from 'lucide-react';

const tabs = [
  { path: '/field-survey', label: '현장조사', icon: ClipboardCheck },
  { path: '/complexes', label: '단지', icon: Building2 },
  { path: '/cards', label: '카드', icon: CreditCard },
  { path: '/stats', label: '통계', icon: BarChart3 },
];

const moreItems = [
  { path: '/', label: '홈 (업로드)', icon: Upload },
  { path: '/officetel-zones', label: '오피스텔 모드', icon: Building },
  { path: '/field-survey/history', label: '조사 이력', icon: History },
  { path: '/map-tools', label: '지도 도구', icon: Map },
  { path: '/map-meta', label: 'MAP META', icon: Compass },
];

const MobileTabBar: React.FC = () => {
  const location = useLocation();
  const [showMore, setShowMore] = useState(false);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  const isMoreActive = moreItems.some(item => isActive(item.path));

  return (
    <>
      {/* More sheet overlay */}
      {showMore && (
        <div
          className="fixed inset-0 bg-black/40 z-40 sm:hidden"
          onClick={() => setShowMore(false)}
        />
      )}

      {/* More sheet */}
      <div
        className={`fixed bottom-0 left-0 right-0 z-50 sm:hidden transition-transform duration-300 ease-out ${
          showMore ? 'translate-y-0' : 'translate-y-full'
        }`}
      >
        <div className="bg-white rounded-t-2xl shadow-tab pb-[calc(64px+env(safe-area-inset-bottom,0px))]">
          <div className="flex items-center justify-between px-5 pt-4 pb-2">
            <span className="text-sm font-bold text-gray-900">더보기</span>
            <button
              onClick={() => setShowMore(false)}
              className="p-1 text-gray-400 active:text-gray-600"
            >
              <X size={20} />
            </button>
          </div>
          <div className="px-2 pb-2">
            {moreItems.map(item => {
              const Icon = item.icon;
              const active = isActive(item.path);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setShowMore(false)}
                  className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-colors ${
                    active
                      ? 'bg-brand-50 text-brand-700'
                      : 'text-gray-700 active:bg-gray-50'
                  }`}
                >
                  <Icon size={20} />
                  <span className="text-sm font-medium">{item.label}</span>
                </Link>
              );
            })}
          </div>
        </div>
      </div>

      {/* Tab bar */}
      <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-100 shadow-tab sm:hidden"
           style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}>
        <div className="flex items-center justify-around h-16">
          {tabs.map(tab => {
            const Icon = tab.icon;
            const active = isActive(tab.path);
            return (
              <Link
                key={tab.path}
                to={tab.path}
                className={`flex flex-col items-center justify-center gap-0.5 w-full h-full transition-colors ${
                  active ? 'text-brand-600' : 'text-gray-400'
                }`}
              >
                <Icon size={22} strokeWidth={active ? 2.5 : 1.8} />
                <span className={`text-[10px] ${active ? 'font-semibold' : 'font-medium'}`}>
                  {tab.label}
                </span>
              </Link>
            );
          })}
          <button
            onClick={() => setShowMore(!showMore)}
            className={`flex flex-col items-center justify-center gap-0.5 w-full h-full transition-colors ${
              isMoreActive || showMore ? 'text-brand-600' : 'text-gray-400'
            }`}
          >
            <MoreHorizontal size={22} strokeWidth={isMoreActive || showMore ? 2.5 : 1.8} />
            <span className={`text-[10px] ${isMoreActive || showMore ? 'font-semibold' : 'font-medium'}`}>
              더보기
            </span>
          </button>
        </div>
      </nav>
    </>
  );
};

export default MobileTabBar;
